<template>
  <div>
    <ConnectionsHistoryHead
        :showFilter="showFilter"
        :countFilterParams="countFilterParams"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @changeTab="(data) => $emit('changeTab', data)"
        @reload="$emit('reload')"
        @selectAll="selectAll"
    />

    <div class="table-filter-wrap">

      <ConnectionsHistoryFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <ConnectionsHistoryTable
          :countFilterParams="countFilterParams"
          :selectedNow="selectedNow"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import ConnectionsHistoryHead from "./ConnectionsHistoryHead/ConnectionsHistoryHead";
  import ConnectionsHistoryFilter from "./ConnectionsHistoryFilter/ConnectionsHistoryFilter";
  import ConnectionsHistoryTable from "./ConnectionsHistoryTable/ConnectionsHistoryTable";

  export default {
    name: "ConnectionsHistoryTableUser",

    components: {
      ConnectionsHistoryHead,
      ConnectionsHistoryFilter,
      ConnectionsHistoryTable,
    },

    props: {
      typeShops: String,
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    watch: {
      filterGetParams(newVal) {
        this.filterGetParams = newVal
      },
      countFilterParams(newVal) {
        this.countFilterParams = newVal
      },
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
